import React from "react";
import { useSelector } from "react-redux";
import PieChart from "../../../../components/pieChart/pieChart";
import NoData from "../../../../components/noData/noData";

const RevenuePieChart = () => {
  const revenuesForPieChart = useSelector((state) => state.revenueBreakdown.revenuesForPieChart);

  const doesPieChartHaveData = () => {
    if (revenuesForPieChart.length === 1 && revenuesForPieChart[0]) {
      const [firstElement] = revenuesForPieChart;
      return firstElement[1] !== 0;
    }

    return !!revenuesForPieChart.length;
  };

  return doesPieChartHaveData ? (
    <PieChart
      showLegend
      legendPosition="right"
      clickablePie={false}
      addOtherLabel={false}
      data={revenuesForPieChart}
      currency="$"
    />
  ) : (
    <NoData />
  );
};
export default RevenuePieChart;
